var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowLeft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_29_2510)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 15,
    r: 15,
    fill: "#191919",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.3625 21.6133C18.4784 21.4976 18.5703 21.3603 18.633 21.209C18.6957 21.0578 18.728 20.8957 18.728 20.732C18.728 20.5683 18.6957 20.4062 18.633 20.255C18.5703 20.1038 18.4784 19.9664 18.3625 19.8508L13.5125 15.0008L18.3625 10.1508C18.5962 9.91704 18.7275 9.60005 18.7275 9.26952C18.7275 8.93898 18.5962 8.62199 18.3625 8.38826C18.1288 8.15454 17.8118 8.02324 17.4812 8.02324C17.1507 8.02324 16.8337 8.15454 16.6 8.38826L10.8625 14.1258C10.7466 14.2414 10.6547 14.3788 10.5919 14.53C10.5292 14.6812 10.4969 14.8433 10.4969 15.007C10.4969 15.1707 10.5292 15.3328 10.5919 15.484C10.6547 15.6353 10.7466 15.7726 10.8625 15.8883L16.6 21.6258C17.075 22.1008 17.875 22.1008 18.3625 21.6133Z",
    fill: "#ECECEC"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_29_2510"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    fill: "white",
    transform: "matrix(-1 0 0 -1 30 30)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowLeft);
export default __webpack_public_path__ + "static/media/Arrow-Left.de051b87d09c34b2877aa9197564eba9.svg";
export { ForwardRef as ReactComponent };